"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Part_1 = require("./_Part");
exports._Parts = {
    type: "list",
    flattened: true,
    member: {
        shape: _Part_1._Part
    }
};
//# sourceMappingURL=_Parts.js.map